
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gWbPjvpKkHk6EQuarwfgomRDnU1s9zTDtecIU4SNBW1MMeta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexMKOPyAIp1f6JBBv6zwGTDuW1TdjKXOVcISLKyQy0Xd0Meta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search9PLRstzw4HRImsRsS6wEXlkRR0N93ZoK4LMaVwOBfW8Meta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexDj7u8QZi1T6ufhS6U1iiAhBPfzJdDPwDmJHL1j2D50EMeta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93b8KsrOT_bcfBuPy9CXlCfBkua9RTiF0rj8W_45DlVevZMMeta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index2jYCSS_FkR6ueYgmZln_gCJr_p9dcdlExH2Jxo1KI1AMeta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Uosmq_45IH7xh8y_E10iukn3IB_45yys0YT7sIL6k7w_MgQMeta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexIXJo4_Ors7jtLT232C9K3a8JpuUGcd_45_45pZpHbXGVInoMeta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93JiXEmqrLqe6ONSTNuWeb49Laqwgq9wT6R6aFmY8W3C0Meta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indextmTVGDdVQDrUL2tPEeKPHa2xIQ8HrEDQVRd7ZHleQhEMeta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexDZUaQNvbhIqF_RaSbJz59_1RCYWa1JYPNJnBRoz937kMeta } from "/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index2jYCSS_FkR6ueYgmZln_gCJr_p9dcdlExH2Jxo1KI1AMeta || {},
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexIXJo4_Ors7jtLT232C9K3a8JpuUGcd_45_45pZpHbXGVInoMeta || {},
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indextmTVGDdVQDrUL2tPEeKPHa2xIQ8HrEDQVRd7ZHleQhEMeta || {},
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexDZUaQNvbhIqF_RaSbJz59_1RCYWa1JYPNJnBRoz937kMeta || {},
    component: () => import("/codebuild/output/src2844148039/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]